import { render, staticRenderFns } from "./agent-create-dialog-new.vue?vue&type=template&id=672293a6&scoped=true"
import script from "./agent-create-dialog-new.vue?vue&type=script&lang=js"
export * from "./agent-create-dialog-new.vue?vue&type=script&lang=js"
import style0 from "./agent-create-dialog-new.vue?vue&type=style&index=0&id=672293a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672293a6",
  null
  
)

export default component.exports